<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="w-12 h-12 rounded-lg text-white p-1 bg-tertiary"
      >
        <icon name="ezines" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        Latest Ezine
      </h3>
    </div>
    <div class="mb-4">
    <loader v-if="loadingEzine" />
    <pl-select v-else name="filter_menu" id="filter_menu" v-model="selectedEzine" class="w-full mb-3" :select-class="['bg-white']">
      <option :value="null" disabled>Please Select</option>
       <option v-for="campaign in campaigns" :key="campaign.id" :value="campaign.id">{{ campaign.name }}</option>
    </pl-select>
    </div>
    <div ></div>
    <a v-if="selectedEzine !== null"
      :href="url"
      target="_blank"
      class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
    >
      View
    </a>
    <copy-button  v-if="selectedEzine !== null" :textToCopy="url"  >
      Copy Link
    </copy-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CopyButton from '@/components/CopyButton'
import api from '@/http'

export default {
  props: [ 'module' ],
  components: {
    CopyButton
  },
  computed: {
    ...mapState(['selectedOffice']),
    url () {
      const networkIds = [2, 7, 8, 100, 56]
      if (networkIds.includes(this.selectedOffice.network_id)) {
        return `https://ezines-v2.propertylogic.net/campaign/${this.selectedEzine}`
      } else {
        return `https://ezines.briefyourmarket.com/campaign/${this.selectedEzine}`
      }
    }
  },
  watch: {
    selectedOffice (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getEzineLinks()
      }
    }
  },
  mounted () {
    this.getEzineLinks()
  },
  data () {
    return {
      loadingEzine: true,
      campaigns: [],
      selectedEzine: null
    }
  },
  methods: {
    getEzineLinks () {
      api.get('ezine/getCampaign', {
        params: {
          clientID: this.selectedOffice.client_id
        }
      }).then(({ data }) => {
        this.campaigns = data
        this.selectedEzine = this.campaigns[0].id
      }).finally(() => {
        this.loadingEzine = false
      }
      )
    }
  }
}
</script>
